import { storage } from 'APP/packages/storage';

export const resetRewardsStorage = (): void => {
  storage.rewards.setRewardAnimationShown(false);
  storage.rewards.clearDontShowRewardBanner();
};
